import { render, staticRenderFns } from "./account-info-group.vue?vue&type=template&id=0d2d554f&scoped=true&"
import script from "./account-info-group.vue?vue&type=script&lang=js&"
export * from "./account-info-group.vue?vue&type=script&lang=js&"
import style0 from "./account-info-group.vue?vue&type=style&index=0&id=0d2d554f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d554f",
  null
  
)

export default component.exports